export const objToURI = (obj) => {
    if (typeof obj !== 'object') return 'bad Format';
    let encodedObject = [];
    for (const property in obj) {
        encodedObject.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));
    }
    encodedObject = encodedObject.join("&");
    return encodedObject;
};

export default objToURI;